import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import OverlayScrollbars from 'overlayscrollbars';
import { AgGridHelperService } from 'src/app/reusables/services/ag-grid-helper.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { TasksService, TasksSharedData } from '../../modules/tasks/tasks.service';
import { DatePipe } from '@angular/common';
import { GetTaskApiModel, LoginDTO } from '../../modules/tasks/tasks.models';

@Component({
  selector: 'cv-tasks-modal',
  templateUrl: './tasks-modal.component.html',
  styleUrls: ['./tasks-modal.component.scss']
})
export class TasksModalComponent implements OnInit {
  @Input() selectedRow: any;
  @Input() moduleKey: string;
  @Input() groupID: number;
  @Input() modalOpen: boolean;
  @Input() dashKey: string;

  public ts: TasksSharedData;
  public data: GetTaskApiModel = null;
  public namePristine = true;
  public dateError = "";
  public cvAngularDateFormat: string = window["CVAngularDateFormat"];
  public cvAngularTimeFormat: string = window["CVAngularTimeFormat"];
  public creatingTask = false;
  
  constructor(
    private activeModal: NgbActiveModal,
    private cvLocalizationService: CVLocalizationService,
    private tasksService: TasksService,
    private datePipe: DatePipe,
) {
    this.ts = this.tasksService.dataObj; 
  }

  async ngOnInit() {
    await this.cvLocalizationService.GetSection("Tasks");
    this.ts.save.AssignToSelf = false;
  }

  close() {
    this.namePristine = true;
    this.ts.save = {
        Name: "",
        StartDate: new Date(Date.today()),
        DueDate: null,
        AssignToSelf: false,
        Assignees: [],
        Signoff: true,
        GroupID: null
    };
    this.activeModal.close();
  }


  public validateDates() {
      if (this.ts.save.DueDate == null) this.dateError = "";
      else if (new Date(Date.now()).compareTo(this.ts.save.DueDate) >= 0)
          this.dateError = this.cvLocalizationService.getCachedText(
              "Tasks",
              "Past_Due_Date",
              "Past Due Date"
          );
      else if (
          new Date(this.ts.save.StartDate).compareTo(this.ts.save.DueDate) >=
          0
      )
          this.dateError = this.cvLocalizationService.getCachedText(
              "Tasks",
              "Invalid_Due_Date",
              "Invalid Due Date"
          );
      else this.dateError = "";
  }

  getLocalizedString(stringToLocalize : string = "Type_Name_Here")
  {
    return this.cvLocalizationService.getCachedText("Tasks", stringToLocalize);
  }

  public async addTask() {
    this.creatingTask = true;
    this.ts.save.GroupID = this.groupID;
    if (this.ts.save.StartDate == null)
        this.ts.save.StartDate = new Date(Date.today());
    await this.tasksService.addTask();
    this.close();
}

}
